import React from 'react';
import BibleApp from './BibleApp';
import './App.css';

const App = () => {
  return (
    <div className="App">
      <BibleApp />
    </div>
  );
};

export default App;